module.exports = __webpack_public_path__ + "img/symbol_5.6753af93.png";